import { ChangeDetectionStrategy, Component, inject, Signal, ViewEncapsulation } from '@angular/core';
import { FiQuizEditorStoreService } from '../../fi-quiz-editor-store.service';

@Component({
    selector: 'fi-quiz-translation-card',
    templateUrl: './quiz-translation-card.component.html',
    styleUrls: ['./quiz-translation-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-quiz-translation-card' },
    standalone: false,
})
export class FiQuizTranslationCardComponent {
    private fiQuizEditorStoreService = inject(FiQuizEditorStoreService);
    protected selectedLanguageId: Signal<number> = this.fiQuizEditorStoreService.selectedLanguageId;

    protected selectedLanguageIdChange(value: number): void {
        this.fiQuizEditorStoreService.setSelectedLanguageId(value);
    }
}
